// @ts-nocheck
import HelloSign from "hellosign-embedded";
export const client = new HelloSign({
  clientId: "0b06b05ccd9944806f7fa5eeba6e6934",
  skipDomainVerification: true,
  timeout: 1200000,
  allowCancel: true,
});